import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { IFaq } from '@propertypal/shared/src/types/strapi';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { MidHeading } from '../typography';
import {
  RelatedArticles,
  RelatedArticlesContainer,
  RelatedArticlesList,
  RelatedArticlesListItem,
} from './FaqRelatedArticles.style';

interface FaqRelatedArticlesProps {
  relatedArticles: IFaq[];
  agent?: boolean;
  onClearQuery: () => void;
}

const FaqRelatedArticles: React.FC<FaqRelatedArticlesProps> = ({ relatedArticles, agent, onClearQuery }) => {
  const { query } = useRouter();

  if (!relatedArticles?.length) return null;

  return (
    <RelatedArticles data-testid="faq-related-articles">
      <RelatedArticlesContainer>
        <MidHeading>Other articles in this section</MidHeading>
        <RelatedArticlesList>
          {relatedArticles.map((a) => (
            <RelatedArticlesListItem key={a.id} data-testid="faq-related-article">
              <Link
                href={`/faq/${agent ? 'agent-faq/' : ''}${a.attributes.subSection?.data?.find(
                  (s) => s.attributes.slug === (query.section as string),
                )?.attributes?.slug}/${a.attributes.slug}`}
                prefetch={false}
                data-testid="faq-related-article-link"
                onClick={onClearQuery}
              >
                <span>{a.attributes.question}</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </Link>
            </RelatedArticlesListItem>
          ))}
        </RelatedArticlesList>
      </RelatedArticlesContainer>
    </RelatedArticles>
  );
};

export default FaqRelatedArticles;
